// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PerformingMedia.css */

:root {
    --input-bg-color-light: #ffffff; /* white for light mode */
    --input-bg-color-dark: #333333; /* dark grey for dark mode */
    --header-bg-color-light: #ffffff; /* white for light mode header */
    --header-bg-color-dark: #333333; /* dark grey for dark mode header */
    --dot-color: rgba(0, 0, 0, 0.5); /* black with 0.5 opacity */
    --input-text-color: #000; /* black for light theme */
  }
  
.performing-media-container {
    padding-top: 64px;
    font-family: 'Nunito Sans', Arial, sans-serif;
    background-color: var(--bg-color);
    transition: background-color .5s;
  }
  
  .performing-media-header {
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    right: 0;
    z-index: 1100; /* Higher than the page content so it stays on top */
    box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Softer shadow */
    background-color: var(--header-bg-color-light);/* Uses the CSS variable for background color */
    transition: background-color .5s;
  }
  
  .performing-media-header.MuiAppBar-root {
    background-color: var(--header-bg-color-light);
}

  .title {
    flex-grow: 1;
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    color:#222;
    display:block;
  }

  .mobile-icon {
    display: none!important; /* Nascondi l'icona */
  }

  
  .animation-container {
    position: relative;
    width: 100%;
    height: 240px; /* Fixed height */
    max-width: 300px;
    margin: 2rem auto;
    overflow:hidden;
    margin:50px auto 50px;
  }
  
  .animation-container video {
    height: calc(100% + 100px);
    max-height: 300px;
    width: auto;
    position: absolute;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    object-fit:cover;
  }
  
  .my-question-buttons {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 10px;
    max-width: 750px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .chat-button {
    margin: 10px;
    cursor: pointer;
    font-family: monospace;
    font-size: 14px;
    width:320px;
  }
 textarea#message-textfield {
    font-family: monospace!important;
    font-weight: bold;; 
    overflow-y: hidden;
    margin:0!important;
  }
  textarea#message-textfield::-webkit-scrollbar {
    display: none;
  }
  .chat-input {
    font-family: monospace;
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 70%;
    border-radius: 20px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    background-color: var(--input-bg-color-light);
    z-index: 100; /* Ensure it's above other content */
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    transition: bottom 0.3s; /* Smooth transition when moving up */
    color: var(--input-text-color);
  }
  textarea#message-textfield {
    color: var(--input-text-color);
  }

  /* Additional styles for the TextField within the chat input */
  .input-label-focused {
    /* Hide the label when the input is focused or has text */
    display: none;
  }
  
  .icon-button-light {
    color: rgba(0, 0, 0, 0.2);
  }
  
  .icon-button-dark {
    color: rgba(255, 255, 255, 0.2);
  }
  .chat-input-form .MuiButtonBase-root {
    font-family: monospace;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin-left: 8px; /* Add some space between the input and the button */
  }
  .chat-input-root.Mui-focused .MuiInputLabel-root {
    display: none;
  }
  .chat-input .MuiTextField-root {
    flex-grow: 1;
  }
  .input-no-label .MuiInputLabel-root {
    display: none;
  }
  
  .input-no-label .MuiInputBase-input {
    padding-bottom: 10px;
  }
  .hide-label {
    visibility: hidden;
  }
  .MuiInputLabel-shrink {
    display: none;
  }
  .chat-input-form {
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
    max-width: 70%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom:20px;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    background-color: var(--input-bg-color-light);
    z-index: 100;
  }
  #send-button {
    margin-bottom:5px;
  }
  .mic-icon {
    position: absolute;
    right: 10px;
  }
  .bubble-container.bot {
    background-color: rgba(0,0,0,0.1);
  }
  .message-bubble.bot-temp {
    justify-content: flex-start;
  }
  .message-bubble {
    display: flex;
    align-items: flex-start;
    margin: 20px auto;
    width: 60%;
    padding: 20px 0;
    animation: slideFadeIn 0.5s ease-out;
  }
  .chat-messages-container {
    display: flex;
    flex-direction: column;
    margin: auto;
    overflow-y: auto;
    padding-bottom:120px;
  }
  .message-bubble .MuiAvatar-root {
    margin-right: 20px;
    width:40px;
    height: 40px;
    border:2px solid white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .user {
    justify-content: flex-start;
  }
  
  .bot {
    justify-content: flex-end;
  }

  .button-container {
    max-width: 50%;
    margin-left: auto;
    margin-right: auto;
}
 .question-container {
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;
}

.button-container .question-chip , .question-container .question-chip {
    background-color: #bbb; /* Black background */
    color: #000; /* White text */
    margin: 2px; /* Add some margin around each button */
    padding: 10px; /* Add some padding inside each button */
    border-radius: 5px; /* Round the corners of the buttons */
    font-family: monospace;
    text-transform: unset;
}
.button-container .question-chip:hover, .question-container .question-chip:hover  {
    background-color: #ccc; /* Dark grey background on hover */  
}
  
  /* Dark mode styles */
  .dark-mode {
    background-color: #2c2c2c;
    color: #f0f0f0;
    --dot-color: rgba(255, 255, 255, 0.7);
    --input-text-color: #fff; /* white for dark theme */
  }
  
  .dark-mode .chat-button {
    background-color: #333333;
    color: #ffffff;
  }
  
  .dark-mode .chat-input {
    background-color: var(--input-bg-color-dark); 
  }
  
  .dark-mode .chat-input .MuiTextField-root {
    background-color: #222;
    color: white;
  }
  .dark-mode .chat-input-form {
    background-color: #222;
    color: white;
}
  .dark-mode .title {
    color: #f1f1f1; /* Light color for the title in dark mode */
  }
  
  .dark-mode .MuiTextField-root {
    label {
      color: #bbb; /* Light color for the label in dark mode */
    }
    input {
      color: #f1f1f1; /* Light color for the input text in dark mode */
    }
    .MuiOutlinedInput-root {
      fieldset {
        borderColor: #f1f1f1; /* Light color for the border in dark mode */
      }
    }
  }
  .dark-mode .performing-media-header {
    background-color: #2c2c2c; /* Dark background for dark mode */
  }
  .dark-mode .performing-media-header.MuiAppBar-root {
    background-color: var(--header-bg-color-dark);
}
  .dark-mode .performing-media-container {
    background-color: #2c2c2c; /* Dark background for dark mode */
  }
  

  .dark-mode .button-container .question-chip, .dark-mode .question-container .question-chip {
    background-color: #222; /* Dark grey background */
    color: #fff; /* White text */
}
.dark-mode .button-container .question-chip:hover, .dark-mode .question-container .question-chip:hover {
  background-color: #555; /* Dark grey background on hover */  
}
  /* Responsive styles for mobile devices */
@media (max-width: 600px) {
    .title {
    display: none; /* Nascondi il titolo */
    }
    .mobile-icon {
        display: block!important; /* Mostra l'icona */
    }
    .chat-input {
      max-width: 90%; /* Make chat input wider on smaller screens */
      left: 5%; /* Align to the left */
      transform: translateX(0); /* Adjust translation */
    }
    .animation-container {
      display: none;
    }
  
    .button-container {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      max-width: 100%;
    }
    .question-chip {
      width: 90%;
    }
    .performing-media-header {
      padding-left: 0; /* Adjust padding for smaller screens */
      padding-right: 0;
    }
  
    .title {
      font-size: 1.2rem; /* Smaller font size for smaller screens */
    }
  
    .question-buttons {
      margin-top: 20px; /* Add some top margin for visibility */
    }
  
    .question-buttons .MuiButton-root {
      padding: 6px 12px; /* Adjust padding for buttons */
      font-size: 0.8rem; /* Smaller font size for buttons */
    }
     /* 1. Allargare le bubble dei messaggi al 100% */
     .message-bubble {
      width: -moz-fit-content;
      width: fit-content;
      padding: 10px;
      margin: 10px 0;
    }

    /* 2. Nascondere gli avatar nelle bubble dei messaggi */
    .message-bubble .MuiAvatar-root {
        display: none;
    .MuiOutlinedInput-root {
      fieldset {
        borderColor: #f1f1f1; /* Light color for the border in dark mode */
      }
    }

      .chat-input {
        max-width: 90%; /* Make chat input wider on smaller screens */
        left: 5%; /* Align to the left */
        transform: translateX(0); /* Adjust translation */
      }
      .animation-container {
        display: none;
      }

      .button-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        max-width: 100%;
      }
      .question-chip {
        width: 90%;
      }
      .performing-media-header {
        padding-left: 0; /* Adjust padding for smaller screens */
        padding-right: 0;
      }

      .title {
        font-size: 1.2rem; /* Smaller font size for smaller screens */
      }

      .question-buttons {
        margin-top: 20px; /* Add some top margin for visibility */
      }

      .question-buttons .MuiButton-root {
        padding: 6px 12px; /* Adjust padding for buttons */
        font-size: 0.8rem; /* Smaller font size for buttons */
      }
       /* 1. Allargare le bubble dei messaggi al 100% */
       .message-bubble {
        width: -moz-fit-content;
        width: fit-content;
        padding: 10px;
        margin: 10px 0;
      }

      /* 2. Nascondere gli avatar nelle bubble dei messaggi */
      .message-bubble .MuiAvatar-root {
          display: none;
      }
    }

    /* 3. Stilizzare il form di input per occupare tutta la larghezza, senza angoli tondi e senza margini */
    .chat-input-form {
        border-radius: 0; /* Rimuove gli angoli tondi */
        left: 0; /* Posiziona a sinistra */
        transform: translateX(0); /* Azzera la trasformazione */
        width: unset; /* Set width to fit the content */
        margin: 0; /* Rimuove i margini */
        max-width:unset;
        padding:0 10px;
    }

    /* 4. Colonnare i bottoni con i question-chip in una colonna */
    .button-container, .question-container {
        display: flex;
        flex-direction: column;
        max-width: 100%;
    }

    .button-container .question-chip, .question-container .question-chip {
        width: 100%; /* Larghezza al 100% per ogni button */
        margin: 5px 0; /* Margini per distanziare i bottoni */
    }
  }
  
  .dark-mode .button-container .question-chip, .dark-mode .question-container .question-chip {
    background-color: #222; /* Dark grey background */
    color: #fff; /* White text */
  }

  .dark-mode .button-container .question-chip:hover, .dark-mode .question-container .question-chip:hover {
    background-color: #555; /* Dark grey background on hover */  
  }
  @keyframes slideFadeIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

@keyframes bounce {
    0%, 80%, 100% { 
        transform: scale(0);
    } 
    40% { 
        transform: scale(1.0);
    }
}

.dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--dot-color);
    margin: 0 2px;
    animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
    animation-delay: -0.32s;
}

.dot:nth-child(2) {
    animation-delay: -0.16s;
} `, "",{"version":3,"sources":["webpack://./src/aibooks/PerformingMedia/PerformingMedia.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,+BAA+B,EAAE,yBAAyB;IAC1D,8BAA8B,EAAE,4BAA4B;IAC5D,gCAAgC,EAAE,gCAAgC;IAClE,+BAA+B,EAAE,mCAAmC;IACpE,+BAA+B,EAAE,2BAA2B;IAC5D,wBAAwB,EAAE,0BAA0B;EACtD;;AAEF;IACI,iBAAiB;IACjB,6CAA6C;IAC7C,iCAAiC;IACjC,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,MAAM;IACN,WAAW;IACX,OAAO;IACP,QAAQ;IACR,aAAa,EAAE,oDAAoD;IACnE,qCAAqC,EAAE,kBAAkB;IACzD,8CAA8C,CAAC,+CAA+C;IAC9F,gCAAgC;EAClC;;EAEA;IACE,8CAA8C;AAClD;;EAEE;IACE,YAAY;IACZ,sCAAsC;IACtC,iBAAiB;IACjB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,uBAAuB,EAAE,qBAAqB;EAChD;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa,EAAE,iBAAiB;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;CACD;IACG,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,sCAAsC;IACtC,6CAA6C;IAC7C,YAAY,EAAE,oCAAoC;IAClD,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB,EAAE,qCAAqC;IAC9D,8BAA8B;EAChC;EACA;IACE,8BAA8B;EAChC;;EAEA,8DAA8D;EAC9D;IACE,yDAAyD;IACzD,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB,EAAE,oDAAoD;EACxE;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;IACb,sCAAsC;IACtC,6CAA6C;IAC7C,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,iCAAiC;EACnC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,uCAAuC;EACzC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;CACC;EACC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,sBAAsB,EAAE,qBAAqB;IAC7C,WAAW,EAAE,eAAe;IAC5B,WAAW,EAAE,uCAAuC;IACpD,aAAa,EAAE,wCAAwC;IACvD,kBAAkB,EAAE,qCAAqC;IACzD,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,sBAAsB,EAAE,kCAAkC;AAC9D;;EAEE,qBAAqB;EACrB;IACE,yBAAyB;IACzB,cAAc;IACd,qCAAqC;IACrC,wBAAwB,EAAE,yBAAyB;EACrD;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,YAAY;AAChB;EACE;IACE,cAAc,EAAE,2CAA2C;EAC7D;;EAEA;IACE;MACE,WAAW,EAAE,2CAA2C;IAC1D;IACA;MACE,cAAc,EAAE,gDAAgD;IAClE;IACA;MACE;QACE,oBAAoB,EAAE,4CAA4C;MACpE;IACF;EACF;EACA;IACE,yBAAyB,EAAE,kCAAkC;EAC/D;EACA;IACE,6CAA6C;AACjD;EACE;IACE,yBAAyB,EAAE,kCAAkC;EAC/D;;;EAGA;IACE,sBAAsB,EAAE,yBAAyB;IACjD,WAAW,EAAE,eAAe;AAChC;AACA;EACE,sBAAsB,EAAE,kCAAkC;AAC5D;EACE,yCAAyC;AAC3C;IACI;IACA,aAAa,EAAE,uBAAuB;IACtC;IACA;QACI,wBAAwB,EAAE,mBAAmB;IACjD;IACA;MACE,cAAc,EAAE,6CAA6C;MAC7D,QAAQ,EAAE,sBAAsB;MAChC,wBAAwB,EAAE,uBAAuB;IACnD;IACA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,uBAAuB;MACvB,eAAe;IACjB;IACA;MACE,UAAU;IACZ;IACA;MACE,eAAe,EAAE,uCAAuC;MACxD,gBAAgB;IAClB;;IAEA;MACE,iBAAiB,EAAE,0CAA0C;IAC/D;;IAEA;MACE,gBAAgB,EAAE,uCAAuC;IAC3D;;IAEA;MACE,iBAAiB,EAAE,+BAA+B;MAClD,iBAAiB,EAAE,kCAAkC;IACvD;KACC,gDAAgD;KAChD;MACC,uBAAkB;MAAlB,kBAAkB;MAClB,aAAa;MACb,cAAc;IAChB;;IAEA,uDAAuD;IACvD;QACI,aAAa;IACjB;MACE;QACE,oBAAoB,EAAE,4CAA4C;MACpE;IACF;;MAEE;QACE,cAAc,EAAE,6CAA6C;QAC7D,QAAQ,EAAE,sBAAsB;QAChC,wBAAwB,EAAE,uBAAuB;MACnD;MACA;QACE,aAAa;MACf;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,uBAAuB;QACvB,eAAe;MACjB;MACA;QACE,UAAU;MACZ;MACA;QACE,eAAe,EAAE,uCAAuC;QACxD,gBAAgB;MAClB;;MAEA;QACE,iBAAiB,EAAE,0CAA0C;MAC/D;;MAEA;QACE,gBAAgB,EAAE,uCAAuC;MAC3D;;MAEA;QACE,iBAAiB,EAAE,+BAA+B;QAClD,iBAAiB,EAAE,kCAAkC;MACvD;OACC,gDAAgD;OAChD;QACC,uBAAkB;QAAlB,kBAAkB;QAClB,aAAa;QACb,cAAc;MAChB;;MAEA,uDAAuD;MACvD;UACI,aAAa;MACjB;IACF;;IAEA,uGAAuG;IACvG;QACI,gBAAgB,EAAE,6BAA6B;QAC/C,OAAO,EAAE,yBAAyB;QAClC,wBAAwB,EAAE,6BAA6B;QACvD,YAAY,EAAE,iCAAiC;QAC/C,SAAS,EAAE,sBAAsB;QACjC,eAAe;QACf,cAAc;IAClB;;IAEA,8DAA8D;IAC9D;QACI,aAAa;QACb,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,WAAW,EAAE,sCAAsC;QACnD,aAAa,EAAE,sCAAsC;IACzD;EACF;;EAEA;IACE,sBAAsB,EAAE,yBAAyB;IACjD,WAAW,EAAE,eAAe;EAC9B;;EAEA;IACE,sBAAsB,EAAE,kCAAkC;EAC5D;EACA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;AAEF;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["/* PerformingMedia.css */\n\n:root {\n    --input-bg-color-light: #ffffff; /* white for light mode */\n    --input-bg-color-dark: #333333; /* dark grey for dark mode */\n    --header-bg-color-light: #ffffff; /* white for light mode header */\n    --header-bg-color-dark: #333333; /* dark grey for dark mode header */\n    --dot-color: rgba(0, 0, 0, 0.5); /* black with 0.5 opacity */\n    --input-text-color: #000; /* black for light theme */\n  }\n  \n.performing-media-container {\n    padding-top: 64px;\n    font-family: 'Nunito Sans', Arial, sans-serif;\n    background-color: var(--bg-color);\n    transition: background-color .5s;\n  }\n  \n  .performing-media-header {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    left: 0;\n    right: 0;\n    z-index: 1100; /* Higher than the page content so it stays on top */\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Softer shadow */\n    background-color: var(--header-bg-color-light);/* Uses the CSS variable for background color */\n    transition: background-color .5s;\n  }\n  \n  .performing-media-header.MuiAppBar-root {\n    background-color: var(--header-bg-color-light);\n}\n\n  .title {\n    flex-grow: 1;\n    font-family: 'Playfair Display', serif;\n    font-size: 1.5rem;\n    color:#222;\n    display:block;\n  }\n\n  .mobile-icon {\n    display: none!important; /* Nascondi l'icona */\n  }\n\n  \n  .animation-container {\n    position: relative;\n    width: 100%;\n    height: 240px; /* Fixed height */\n    max-width: 300px;\n    margin: 2rem auto;\n    overflow:hidden;\n    margin:50px auto 50px;\n  }\n  \n  .animation-container video {\n    height: calc(100% + 100px);\n    max-height: 300px;\n    width: auto;\n    position: absolute;\n    top: -35px;\n    left: 50%;\n    transform: translateX(-50%);\n    object-fit:cover;\n  }\n  \n  .my-question-buttons {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    max-width: 750px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .chat-button {\n    margin: 10px;\n    cursor: pointer;\n    font-family: monospace;\n    font-size: 14px;\n    width:320px;\n  }\n textarea#message-textfield {\n    font-family: monospace!important;\n    font-weight: bold;; \n    overflow-y: hidden;\n    margin:0!important;\n  }\n  textarea#message-textfield::-webkit-scrollbar {\n    display: none;\n  }\n  .chat-input {\n    font-family: monospace;\n    position: fixed;\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 70%;\n    border-radius: 20px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n    background-color: var(--input-bg-color-light);\n    z-index: 100; /* Ensure it's above other content */\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    transition: bottom 0.3s; /* Smooth transition when moving up */\n    color: var(--input-text-color);\n  }\n  textarea#message-textfield {\n    color: var(--input-text-color);\n  }\n\n  /* Additional styles for the TextField within the chat input */\n  .input-label-focused {\n    /* Hide the label when the input is focused or has text */\n    display: none;\n  }\n  \n  .icon-button-light {\n    color: rgba(0, 0, 0, 0.2);\n  }\n  \n  .icon-button-dark {\n    color: rgba(255, 255, 255, 0.2);\n  }\n  .chat-input-form .MuiButtonBase-root {\n    font-family: monospace;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    margin-left: 8px; /* Add some space between the input and the button */\n  }\n  .chat-input-root.Mui-focused .MuiInputLabel-root {\n    display: none;\n  }\n  .chat-input .MuiTextField-root {\n    flex-grow: 1;\n  }\n  .input-no-label .MuiInputLabel-root {\n    display: none;\n  }\n  \n  .input-no-label .MuiInputBase-input {\n    padding-bottom: 10px;\n  }\n  .hide-label {\n    visibility: hidden;\n  }\n  .MuiInputLabel-shrink {\n    display: none;\n  }\n  .chat-input-form {\n    position: fixed;\n    bottom: 10px;\n    left: 0;\n    right: 0;\n    max-width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom:20px;\n    border-radius: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    padding: 1rem;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n    background-color: var(--input-bg-color-light);\n    z-index: 100;\n  }\n  #send-button {\n    margin-bottom:5px;\n  }\n  .mic-icon {\n    position: absolute;\n    right: 10px;\n  }\n  .bubble-container.bot {\n    background-color: rgba(0,0,0,0.1);\n  }\n  .message-bubble.bot-temp {\n    justify-content: flex-start;\n  }\n  .message-bubble {\n    display: flex;\n    align-items: flex-start;\n    margin: 20px auto;\n    width: 60%;\n    padding: 20px 0;\n    animation: slideFadeIn 0.5s ease-out;\n  }\n  .chat-messages-container {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n    overflow-y: auto;\n    padding-bottom:120px;\n  }\n  .message-bubble .MuiAvatar-root {\n    margin-right: 20px;\n    width:40px;\n    height: 40px;\n    border:2px solid white;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .user {\n    justify-content: flex-start;\n  }\n  \n  .bot {\n    justify-content: flex-end;\n  }\n\n  .button-container {\n    max-width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n}\n .question-container {\n  max-width: 70%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.button-container .question-chip , .question-container .question-chip {\n    background-color: #bbb; /* Black background */\n    color: #000; /* White text */\n    margin: 2px; /* Add some margin around each button */\n    padding: 10px; /* Add some padding inside each button */\n    border-radius: 5px; /* Round the corners of the buttons */\n    font-family: monospace;\n    text-transform: unset;\n}\n.button-container .question-chip:hover, .question-container .question-chip:hover  {\n    background-color: #ccc; /* Dark grey background on hover */  \n}\n  \n  /* Dark mode styles */\n  .dark-mode {\n    background-color: #2c2c2c;\n    color: #f0f0f0;\n    --dot-color: rgba(255, 255, 255, 0.7);\n    --input-text-color: #fff; /* white for dark theme */\n  }\n  \n  .dark-mode .chat-button {\n    background-color: #333333;\n    color: #ffffff;\n  }\n  \n  .dark-mode .chat-input {\n    background-color: var(--input-bg-color-dark); \n  }\n  \n  .dark-mode .chat-input .MuiTextField-root {\n    background-color: #222;\n    color: white;\n  }\n  .dark-mode .chat-input-form {\n    background-color: #222;\n    color: white;\n}\n  .dark-mode .title {\n    color: #f1f1f1; /* Light color for the title in dark mode */\n  }\n  \n  .dark-mode .MuiTextField-root {\n    label {\n      color: #bbb; /* Light color for the label in dark mode */\n    }\n    input {\n      color: #f1f1f1; /* Light color for the input text in dark mode */\n    }\n    .MuiOutlinedInput-root {\n      fieldset {\n        borderColor: #f1f1f1; /* Light color for the border in dark mode */\n      }\n    }\n  }\n  .dark-mode .performing-media-header {\n    background-color: #2c2c2c; /* Dark background for dark mode */\n  }\n  .dark-mode .performing-media-header.MuiAppBar-root {\n    background-color: var(--header-bg-color-dark);\n}\n  .dark-mode .performing-media-container {\n    background-color: #2c2c2c; /* Dark background for dark mode */\n  }\n  \n\n  .dark-mode .button-container .question-chip, .dark-mode .question-container .question-chip {\n    background-color: #222; /* Dark grey background */\n    color: #fff; /* White text */\n}\n.dark-mode .button-container .question-chip:hover, .dark-mode .question-container .question-chip:hover {\n  background-color: #555; /* Dark grey background on hover */  \n}\n  /* Responsive styles for mobile devices */\n@media (max-width: 600px) {\n    .title {\n    display: none; /* Nascondi il titolo */\n    }\n    .mobile-icon {\n        display: block!important; /* Mostra l'icona */\n    }\n    .chat-input {\n      max-width: 90%; /* Make chat input wider on smaller screens */\n      left: 5%; /* Align to the left */\n      transform: translateX(0); /* Adjust translation */\n    }\n    .animation-container {\n      display: none;\n    }\n  \n    .button-container {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: center;\n      max-width: 100%;\n    }\n    .question-chip {\n      width: 90%;\n    }\n    .performing-media-header {\n      padding-left: 0; /* Adjust padding for smaller screens */\n      padding-right: 0;\n    }\n  \n    .title {\n      font-size: 1.2rem; /* Smaller font size for smaller screens */\n    }\n  \n    .question-buttons {\n      margin-top: 20px; /* Add some top margin for visibility */\n    }\n  \n    .question-buttons .MuiButton-root {\n      padding: 6px 12px; /* Adjust padding for buttons */\n      font-size: 0.8rem; /* Smaller font size for buttons */\n    }\n     /* 1. Allargare le bubble dei messaggi al 100% */\n     .message-bubble {\n      width: fit-content;\n      padding: 10px;\n      margin: 10px 0;\n    }\n\n    /* 2. Nascondere gli avatar nelle bubble dei messaggi */\n    .message-bubble .MuiAvatar-root {\n        display: none;\n    .MuiOutlinedInput-root {\n      fieldset {\n        borderColor: #f1f1f1; /* Light color for the border in dark mode */\n      }\n    }\n\n      .chat-input {\n        max-width: 90%; /* Make chat input wider on smaller screens */\n        left: 5%; /* Align to the left */\n        transform: translateX(0); /* Adjust translation */\n      }\n      .animation-container {\n        display: none;\n      }\n\n      .button-container {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        max-width: 100%;\n      }\n      .question-chip {\n        width: 90%;\n      }\n      .performing-media-header {\n        padding-left: 0; /* Adjust padding for smaller screens */\n        padding-right: 0;\n      }\n\n      .title {\n        font-size: 1.2rem; /* Smaller font size for smaller screens */\n      }\n\n      .question-buttons {\n        margin-top: 20px; /* Add some top margin for visibility */\n      }\n\n      .question-buttons .MuiButton-root {\n        padding: 6px 12px; /* Adjust padding for buttons */\n        font-size: 0.8rem; /* Smaller font size for buttons */\n      }\n       /* 1. Allargare le bubble dei messaggi al 100% */\n       .message-bubble {\n        width: fit-content;\n        padding: 10px;\n        margin: 10px 0;\n      }\n\n      /* 2. Nascondere gli avatar nelle bubble dei messaggi */\n      .message-bubble .MuiAvatar-root {\n          display: none;\n      }\n    }\n\n    /* 3. Stilizzare il form di input per occupare tutta la larghezza, senza angoli tondi e senza margini */\n    .chat-input-form {\n        border-radius: 0; /* Rimuove gli angoli tondi */\n        left: 0; /* Posiziona a sinistra */\n        transform: translateX(0); /* Azzera la trasformazione */\n        width: unset; /* Set width to fit the content */\n        margin: 0; /* Rimuove i margini */\n        max-width:unset;\n        padding:0 10px;\n    }\n\n    /* 4. Colonnare i bottoni con i question-chip in una colonna */\n    .button-container, .question-container {\n        display: flex;\n        flex-direction: column;\n        max-width: 100%;\n    }\n\n    .button-container .question-chip, .question-container .question-chip {\n        width: 100%; /* Larghezza al 100% per ogni button */\n        margin: 5px 0; /* Margini per distanziare i bottoni */\n    }\n  }\n  \n  .dark-mode .button-container .question-chip, .dark-mode .question-container .question-chip {\n    background-color: #222; /* Dark grey background */\n    color: #fff; /* White text */\n  }\n\n  .dark-mode .button-container .question-chip:hover, .dark-mode .question-container .question-chip:hover {\n    background-color: #555; /* Dark grey background on hover */  \n  }\n  @keyframes slideFadeIn {\n    0% {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n@keyframes bounce {\n    0%, 80%, 100% { \n        transform: scale(0);\n    } \n    40% { \n        transform: scale(1.0);\n    }\n}\n\n.dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: var(--dot-color);\n    margin: 0 2px;\n    animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.dot:nth-child(1) {\n    animation-delay: -0.32s;\n}\n\n.dot:nth-child(2) {\n    animation-delay: -0.16s;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
